// Type definitions for ReportMapping API based on ForvalterEOSApi controller

export interface ReportDto {
    /** Report Id from Energinet */
    id: string;
    name: string | null;
    title: string;
    type: string;
    description: string;
}

export interface ReportWithMappingDto extends ReportDto {
    mapping: ReportMapping | null;
    isMapped: boolean;
}

export interface ReportMapping {
    reportId: string;
    /** D365 byggnummer */
    byggNummer: string;
    /** D365 kundenummer */
    kundenummer: string | null;
    /** Valid values: see ReportType enum */
    reportType: string;
    externalId: string | null;
}

export enum MeassurementCategoryEnum {
    Waste = 'Waste',
    Energy = 'Energy',
    Water = 'Water',
    MonthlyEnergy = 'MonthlyEnergy',
    AdjustedEnergy = 'AdjustedEnergy',
    MonthlyCustomerEnergy = 'MonthlyCustomerEnergy',
    CustomerSpecificEnergy = 'CustomerSpecificEnergy',
}

export type ReportMappingSearchParams = {
    navnOrNummer?: string;
};

export type ReportWithMappingFlattened = ReportWithMappingDto & {
    byggNummer?: string;
    kundenummer?: string;
    reportType?: string;
};
